var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phosphor Icons / Funnel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94703 3.75C3.94695 3.75 3.94711 3.75 3.94703 3.75H20.0533C20.3442 3.75009 20.6291 3.8348 20.8728 3.99381C21.1165 4.15282 21.3086 4.37926 21.4259 4.64555C21.5431 4.91184 21.5804 5.20648 21.5331 5.49357C21.486 5.78012 21.3567 6.0468 21.1609 6.26126C21.1605 6.26167 21.1601 6.26209 21.1598 6.2625L15.0002 13.0409V18.344C15.0018 18.5935 14.9407 18.8394 14.8226 19.0592C14.7047 19.2787 14.5337 19.465 14.3253 19.6013L11.3282 21.5962L11.3252 21.5982C11.1001 21.7465 10.8393 21.8313 10.5701 21.8439C10.3009 21.8565 10.0332 21.7963 9.79534 21.6696C9.55744 21.543 9.35805 21.3546 9.21813 21.1243C9.07821 20.894 9.00292 20.6302 9.00019 20.3607L9.00011 20.3531L9.00015 13.0409L8.99817 13.0388L2.84054 6.2625C2.8402 6.26213 2.83987 6.26177 2.83954 6.2614C2.6437 6.04692 2.51434 5.78018 2.46717 5.49357C2.41993 5.20648 2.4572 4.91184 2.57444 4.64555C2.69169 4.37926 2.88385 4.15282 3.12752 3.99381C3.37102 3.83491 3.65546 3.7502 3.94621 3.75M20.053 5.25H3.94727L3.94897 5.25186L10.1055 12.0268C10.3615 12.3032 10.5027 12.6668 10.5002 13.0436V20.3455L13.5001 18.3486L13.5001 18.3469L13.5002 13.0436C13.4976 12.6668 13.6388 12.3032 13.8948 12.0268L20.0513 5.25186L20.053 5.25Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.0e8e42f37d85493c6ddeaed08d3445e4.svg";
export { ForwardRef as ReactComponent };